import { useEffect, useCallback, useRef, useState } from 'react';

const useIsMounted = () => {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => { isMounted.current = false };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return useCallback(() => isMounted.current, []);
};

export function useAsyncState<T>(defaultValue: T): [T, (t: T) => void] {
    const isMounted = useIsMounted();
    const [value, setRawValue] = useState<T>(defaultValue);
    const setValue = useCallback((newValue) => {
        if (isMounted()) {
            setRawValue(newValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [value, setValue];
};